import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import '../../styles/auth.css';
import { useAuth, useLocale } from '../../context';
import LoginForm from './LoginForm';
import { lockScroll, unlockScroll } from '../../scrollLock';

function IconClose() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M.456.454a1.094 1.094 0 0 1 1.548 0L9 7.468 16 .454A1.094 1.094 0 0 1 17.546 2l-7.014 6.998 7.015 6.998a1.087 1.087 0 0 1 0 1.545l-.002.003a1.09 1.09 0 0 1-1.545 0l-6.999-7.016-6.998 7.015v.001a1.09 1.09 0 0 1-1.545 0l-.003-.003a1.087 1.087 0 0 1 0-1.544l.001-.001 7.015-6.998L.456 2a1.094 1.094 0 0 1 0-1.547"
      />
    </svg>
  );
}

export default function LoginModal({ onClose, onRegister, onForgot }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const { user } = useAuth();
  const [phase, setPhase] = useState('credentials');

  useEffect(() => {
    if (user && phase !== 'passkey-offer') onClose();
  }, [user, onClose, phase]);

  if (user && phase !== 'passkey-offer') return null;

  useEffect(() => {
    lockScroll();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      unlockScroll();
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  return createPortal(
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className={`auth-modal${phase === 'expired' ? ' auth-modal--expired' : ''}`} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="auth-modal-title">
        <button type="button" className="auth-modal__close" onClick={onClose} aria-label="Close">
          <IconClose />
        </button>
        {phase !== 'expired' && (
          <h1 id="auth-modal-title" className="auth-modal__title">{tr('auth.login.title')}</h1>
        )}
        <LoginForm
          variant="modal"
          onPhaseChange={setPhase}
          onSuccess={onClose}
          onRegisterClick={() => { onClose(); onRegister(); }}
          onForgotClick={() => { onClose(); onForgot?.(); }}
        />
      </div>
    </div>,
    document.body,
  );
}
